import firebase from 'firebase/app'
import 'firebase/auth'
import Hotjar from 'vue-hotjar'

const actions = {
  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER', payload)
    if (this._vm.$hj) {
      this._vm.$hj('identify', payload.id, {
        email: payload.email
      })
    }
  },

  async logoutUser({ commit }) {
    await firebase.auth().signOut()
    commit('CLEAN_USER')
  },

  async cleanAll({ commit }) {
    await firebase.auth().signOut()
    commit('CLEAN_ALL')
  },

  changeLang({ commit }, payload) {
    commit('CHANGE_LANG', payload)
  },
  setError({ commit }, payload) {
    commit('SET_ERROR', payload)
  },
  cleanError({ commit }, payload) {
    commit('CLEAN_ERROR', payload)
  },
  openModal({ commit }, payload) {
    commit('OPEN_MODAL', payload)
  },
  resetModal({ commit }) {
    commit('RESET_MODAL')
  }
}

export default actions
